import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { sightings } from "@/data/sightingsData";
import { useSEO } from "@/hooks/useSEO";

const Sightings = () => {
  useSEO({
    title: "All Loch Ness Monster Sightings | Loch Ness Story",
    description:
      "Browse every documented Loch Ness Monster sighting in our archive — from Saint Columba in 565 AD to modern photographs and scientific investigations.",
    canonical: "/sightings",
    ogImage: "/lovable-uploads/74638626-9ce3-4018-94b3-ec8980da02b9.png",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "All Loch Ness Monster Sightings",
      url: "https://www.lochnessstory.com/sightings",
      hasPart: sightings.map((s) => ({
        "@type": "Article",
        headline: s.title,
        url: `https://www.lochnessstory.com/sightings/${s.id}`,
        image: `https://www.lochnessstory.com${s.image}`,
        datePublished: s.date,
      })),
    },
  });

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-12">
        <header className="mb-10 max-w-3xl">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-3">
            All Sightings
          </h1>
          <p className="text-muted-foreground text-lg">
            Every documented Loch Ness Monster sighting in our archive — historical accounts,
            famous photographs, and modern investigations.
          </p>
        </header>

        <ul className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {sightings.map((s) => (
            <li key={s.id}>
              <Link
                to={`/sightings/${s.id}`}
                className="group block rounded-lg overflow-hidden border border-border bg-card hover:border-primary transition-colors"
              >
                <div className="aspect-video overflow-hidden bg-muted">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <div className="text-xs text-muted-foreground uppercase tracking-wide mb-2">
                    {s.date}
                  </div>
                  <h2 className="font-serif text-lg font-semibold text-foreground group-hover:text-primary transition-colors">
                    {s.title}
                  </h2>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <Footer />
    </div>
  );
};

export default Sightings;
